export default "__VITE_ASSET__$SaUYood__"